




















































































import { computed, defineComponent, ref, toRefs, PropType } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { formatDuration } from '@tt4b/ttam-utils';
import TtamMaterialCover from '@/components/common/material-cover/index.vue';
import TtamExpansionPanel from '@/components/common/expansion-panel/index.vue';

export default defineComponent({
  name: 'TtamMaterialDetail',

  components: {
    TtamMaterialCover,
    TtamExpansionPanel,
  },

  props: {
    isVideo: {
      type: Boolean,
      default: true,
    },
    /** 素材相关信息 */
    materialInfo: {
      type: Object as PropType<{ fileName: string; duration: number; width: number; height: number }>,
      default: () => ({}),
      required: true,
    },
    /** 素材封面地址 */
    coverUrl: {
      type: String,
      default: '',
      required: true,
    },
    // 素材建议列表
    suggestionList: {
      type: Array,
      default: () => [] as PropType<string[]>,
    },
    // 预校验请求中
    preCheckLoading: {
      type: Boolean,
      default: false,
    },
    // 操作按钮，hover才出现
    isHoverButtons: {
      type: Boolean,
      default: false,
    },
    // 是否展示仙女棒图标（标识是否优化过）
    isShowMagicIcon: {
      type: Boolean,
      default: false,
    },
    defaultExpend: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { isVideo, materialInfo, suggestionList, preCheckLoading, defaultExpend } = toRefs(props);

    /** 素材名称 */
    const materialName = computed(() => materialInfo.value.fileName);
    /** 视频时长 */
    const videoDuration = computed(() => `${formatDuration(materialInfo.value.duration)}` || '');
    /** 素材分辨率 */
    const materialResolution = computed(() => `${materialInfo.value.width} * ${materialInfo.value.height}`);

    /**
     * 素材建议相关逻辑 START
     */
    const expansionNode = ref();
    const isExpansion = ref(defaultExpend.value);
    function handleExpand(val: boolean) {
      isExpansion.value = val;
      val ? expansionNode.value?.setExpandON() : expansionNode.value?.setExpandOFF();
    }

    /** 素材本地校验通过，预校验正在请求中【在素材信息右侧展示loading图】*/
    const isPassPreChecking = computed(() => suggestionList.value.length === 0 && preCheckLoading.value);

    /** 素材本地校验不通过，预校验正在请求中【在建议列表下方展示loading图】 */
    const isNoPassPreChecking = computed(() => suggestionList.value.length > 0 && preCheckLoading.value);

    /** 预校验提示文案 */
    const preCheckingLabel = computed(() =>
      isVideo.value
        ? i18n.t('module_ad_material_list_checking_tips')
        : i18n.t('module_ad_material_list_checking_image_tips'),
    );

    return {
      expansionNode,
      materialName,
      videoDuration,
      materialResolution,
      isExpansion,
      isPassPreChecking,
      isNoPassPreChecking,
      preCheckingLabel,
      handleExpand,
    };
  },
});
